<template>
    <div class="jobs-table-garden-help">
        <b-overlay :show="show_overlay" variant="success" :opacity=".5" rounded="sm" style="min-height:100%">

            <b-card no-body>
                <b-card-header>
                    <b-row>
                        <b-col>
                            <h3 class="mt-2 mb-1">{{ title }} ({{ total_items }})</h3>
                        </b-col>
                    </b-row>
                </b-card-header>
                <b-card-body class="pt-1">

                    <b-table-simple class="gardenHelpTable gardenHelpJobsTable " responsive stacked="md">
                        <!-- <b-thead>
                        <b-tr>
                            <b-th class="text-center">Created At</b-th>
                            <b-th class="text-center">Scheduled At</b-th>
                            <b-th>Job No.</b-th>
                            <b-th>Customer Name</b-th>
                            <b-th>Location</b-th>
                            <b-th>Description</b-th>
                            <b-th>Service Type</b-th>
                            <b-th class="text-center" v-if="type != 'requests'">Job Status</b-th>
                        </b-tr>
                    </b-thead> -->
                        <b-tbody v-if="jobs.length > 0">
                            <b-tr v-for="(job, index) in jobs" :key="index" @click="clickViewJob(job)">
                                <b-td stacked-heading="Created At">
                                    Initiated {{ job.created_at }}
                                </b-td>
                                <b-td stacked-heading="Service Type">
                                    <p class="dateTdSpan" v-if="type=='offers'">
                                        {{ getServicesNamesFromObject(job.model.services, false) }}</p>
                                    <p class="dateTdSpan" v-if="job.services">
                                        {{ getServicesNamesFromObject(job.services, false) }}</p>
                                    <p class="dateTdSpan" v-else>{{ job.service_type }}</p>
                                </b-td>
                                <b-td stacked-heading="Contractor" v-if="type=='offers'">
                                    {{ job.owner ? job.owner.name : "" }}
                                </b-td>
                                <b-td stacked-heading="Contractor" v-else>
                                    {{ job.operator ? job.operator.name : "" }}
                                    {{ job.contractor ? job.contractor : "" }}
                                </b-td>
                            </b-tr>
                        </b-tbody>
                        <b-tbody v-else>
                            <b-tr>
                                <b-td colspan="3" class="text-center cursor-initial">
                                    No results found
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                    <!-- pagination -->

                    <b-row cols="1" cols-md="2">
                        <b-col>
                            <p class="data-list-info-garden-help">
                                Showing {{ from_page }} to {{ to_page }} of
                                {{ total_items }} entries
                            </p>
                        </b-col>
                        <b-col>
                            <b-pagination class="pagination-garden-help" v-model="currentPage" :total-rows="total_items"
                                :per-page="perPage" limit="7" @change="changePage" size="md"></b-pagination></b-col>
                    </b-row>
                </b-card-body>
            </b-card>
        </b-overlay>
    </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import InputCheckboxFilter from "../../components/InputCheckboxFilter.vue";

import { getServicesNamesFromObject } from "@/utils/helper-functions-garden-help.js"


export default {
    name: "JobsTable",
    components: { InputCheckboxFilter },
    props: ["type", "title"],
    data() {
        return {
            client_name: "GARDENHELP",
            user_type: localStorage.getItem('user_type'),
            user_id: null, // logined user
            show_overlay: false,

            jobs: [

            ],
            // pagination
            perPage: 5,
            currentPage: 1,
            total_items: 0,
            from_page: 0,
            to_page: 0,
        }
    },
    mounted() {
        let user = JSON.parse(window.localStorage.getItem("user"));
        this.user_id = user.id

        console.log(this.type)

        // if (this.type == 'offers') {
        //     this.jobs = [{
        //         id: 1, created_at: "Initiated Jul 15, 2022", scheduled_at: "28 Feb 23 10:36 AM", job_number: "122345",
        //         customer_name: "sara reda", location: "Maadi, Cairo", description: "test desc", service_type: "Garden Design, Garden Maintenance", status: "accepted",
        //         contractor: "mohamed"
        //     }, {
        //         id: 2, created_at: "Initiated Jul 15, 2022", scheduled_at: "28 Feb 23 10:36 AM", job_number: "213112",
        //         customer_name: "sara reda", location: "Maadi, Cairo", description: "test desc", service_type: "Garden Design, Garden Maintenance", status: "on_route",
        //         contractor: "mohamed"
        //     }]
        // }
        // else {
        this.getJobsList(this.type)
        // }


    },
    methods: {
        getServicesNamesFromObject,
        changePage(value) {
            console.log("change page", value);
            this.currentPage = value
            this.getJobsList(this.type)
        },
        clickViewJob(job) {
            if(this.type=='offers'){
                this.$router.push({ name: "GardenHelpJobsTableJobDetails", params: { status: this.type, id: job.model.id } });
            }else{
                this.$router.push({ name: "GardenHelpJobsTableJobDetails", params: { status: this.type, id: job.id } });
            }
        },
        getJobsList(type) {
            console.log("in get jobs list", type, this.user_type, this.user_id)
            this.show_overlay = true

            let params_request = "?per_page=" + this.perPage + "&page=" + this.currentPage;
            console.log(params_request)

            // params_request += "&contact_id=144"
            if (this.type != 'offers') {
                if (type == 'history') {
                    params_request += "&status=complete"
                }
                else if (type == 'requests') {
                    params_request += "&status=pending,assigned"
                }
                else if (type == 'current') {
                    params_request += "&status=accepted,accepted_quote,on_route,arrived,in_progress"
                }

                console.log(params_request)

                axios
                    .get("/jobs/jobs" + params_request, {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            client: this.client_name,
                            Authorization:
                                "Bearer " +
                                JSON.parse(window.localStorage.getItem("user")).access_token,
                        },
                    })
                    .then((response) => {
                        console.log(response)
                        console.log(response.data)
                        console.log(response)
                        this.jobs = response.data.data;

                        this.total_items = response.data.meta.total
                        if (response.data.meta.total == 0) {
                            this.from_page = 0
                            this.to_page = 0
                        } else {
                            this.from_page = ((this.currentPage - 1) * this.perPage) + 1
                            this.to_page = this.currentPage * this.perPage > response.data.meta.total ? response.data.meta.total : this.currentPage * this.perPage
                        }
                        this.show_overlay = false

                    });
            }
            else {
                axios
                    .get("/payment/invoices" + params_request + '&special_filter=job_owner&status=quote', {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            client: this.client_name,
                            Authorization:
                                "Bearer " +
                                JSON.parse(window.localStorage.getItem("user")).access_token,
                        },
                    })
                    .then((response) => {
                        console.log(response)
                        console.log(response.data)
                        console.log(response)
                        this.jobs = response.data.data;

                        this.total_items = response.data.meta.total
                        if (response.data.meta.total == 0) {
                            this.from_page = 0
                            this.to_page = 0
                        } else {
                            this.from_page = ((this.currentPage - 1) * this.perPage) + 1
                            this.to_page = this.currentPage * this.perPage > response.data.meta.total ? response.data.meta.total : this.currentPage * this.perPage
                        }
                        // this.jobs = response.data.data;

                        // this.total_items = response.data.meta.total
                        // if (response.data.meta.total == 0) {
                        //     this.from_page = 0
                        //     this.to_page = 0
                        // } else {
                        //     this.from_page = ((this.currentPage - 1) * this.perPage) + 1
                        //     this.to_page = this.currentPage * this.perPage > response.data.meta.total ? response.data.meta.total : this.currentPage * this.perPage
                        // }
                        this.show_overlay = false

                    });

            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/jobs/jobs_table/JobsTable.vue